import { render } from "./WorkflowSelector.vue?vue&type=template&id=9b288af0&scoped=true"
import script from "./WorkflowSelector.vue?vue&type=script&lang=ts"
export * from "./WorkflowSelector.vue?vue&type=script&lang=ts"

import "./WorkflowSelector.vue?vue&type=style&index=0&id=9b288af0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9b288af0"

export default script